const mutations = {
  setFavorites (state, favorites) {
    state.favorites = favorites
  },
  insertFavorites (state, favorites) {
    state.favorites.push(favorites)
  },
  deleteFavorites (state, data) {
    state.favorites.splice(state.favorites.indexOf(data), 1)
  },
  setAdverts (state, data) {
    state.adverts = data
  }
}

export default mutations
